import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SimpleModal, Icon, getUtility } from '@livable/saas-react-components';
import { Button, Typography } from '@mui/material';
import useStyles from './styles';
import { ModalContent } from './content';
import { toJS } from 'mobx';
export default function GLModal(_ref) {
  var _getUtility, _getUtility2;
  let utility = _ref.utility,
    disabledTrigger = _ref.disabledTrigger,
    onSaveAndClose = _ref.onSaveAndClose,
    onSaveAndCloseCustom = _ref.onSaveAndCloseCustom,
    isEdit = _ref.isEdit;
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    modalState = _useState2[0],
    setModalState = _useState2[1];
  const modalTitle = /*#__PURE__*/React.createElement("div", {
    className: classes.modalHeader
  }, /*#__PURE__*/React.createElement("span", null, (_getUtility = getUtility(toJS(utility).name || toJS(utility).utilityTypeName)) === null || _getUtility === void 0 ? void 0 : _getUtility.icon({
    pattern: 'gradient'
  })), /*#__PURE__*/React.createElement(Typography, {
    variant: "h3"
  }, (_getUtility2 = getUtility(toJS(utility).name || toJS(utility).utilityTypeName)) === null || _getUtility2 === void 0 ? void 0 : _getUtility2.title, ' ', t('add_new_property_flow.configuration')), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    color: "light"
  }, "/ GL account"));
  const modalSubTitle = /*#__PURE__*/React.createElement("div", {
    className: classes.flex
  }, utility.utilityProviderName);
  return /*#__PURE__*/React.createElement(SimpleModal, {
    key: "GL_Configuration_MODAL",
    id: "GL_Configuration_MODAL_ID",
    trigger: /*#__PURE__*/React.createElement(Button, {
      key: "GL_actionButton",
      variant: "actionButton",
      onClick: () => {
        setModalState(true);
      },
      'custom-attribute': '169-gl-modal'
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "edit"
    }), /*#__PURE__*/React.createElement("span", {
      className: "actionText"
    }, t('general.edit'))),
    disabledTrigger: disabledTrigger,
    title: modalTitle,
    subTitle: modalSubTitle,
    noFooter: true,
    noPadding: true,
    variant: "staticHeight",
    transparentBackdrop: !isEdit,
    isOpen: modalState,
    handleOpen: () => setModalState(true),
    handleClose: () => {
      setModalState(false);
    }
  }, /*#__PURE__*/React.createElement(ModalContent, {
    utility: utility,
    onSaveAndClose: onSaveAndClose,
    onSaveAndCloseCustom: onSaveAndCloseCustom
  }));
}